import {
  OmpAccentStyle,
  OmpButtonPlacement,
  OmpCalloutIcon,
  OmpCalloutLayout,
  OmpCalloutTone,
  OmpColumnsLayout,
  OmpColumnsVerticalAlign,
  OmpContentAlignment,
  OmpFaqLayout,
  OmpHeadingAlignment,
  OmpHeadingSize,
  OmpImageFit,
  OmpImageRatio,
  OmpInstagramLayout,
  OmpMobileLayout,
  OmpControlKey,
  OmpLegacyControlKey,
  OmpMoment,
  OmpMomentAction,
  OmpMomentActionKey,
  OmpPillButtonStyle,
  OmpSectionKey,
  OmpTextAlignment,
  OmpTextImageLayout,
  OmpVideoAspect,
} from '../../_models';
import { momentStripColor, paletteSectionDefaults } from './omp-palette';
import {
  ompMomentActionKeys,
  OmpMomentActionDefs,
  OmpMomentActionsField,
  OmpMomentDiscountMoments,
  ompControlKeys,
  ompControlLabelField,
  ompControlSeedLabel,
  ompControlToggleField,
  OmpControlButtons,
  OmpPageBottomOrderField,
} from '../order-management-portal.sections';

// Default field values per section type's settings form (the persisted `data` blob).
export const OmpSectionDataDefaults: { [key: string]: any } = {
  [OmpSectionKey.AnnouncementBar]: {
    text: '',
    banner_background_color: '#000000',
    link_url: '',
  },
  [OmpSectionKey.WelcomeMessage]: {
    heading: 'Welcome back, {first_name}',
    text_size: OmpHeadingSize.Medium,
  },
  [OmpSectionKey.NextOrderDetails]: {
    offer_strip_text: '',
    offer_strip_background_color: '#000000',
    offer_strip_text_color: '#FFFFFF',
    show_send_now: true,
    show_reschedule: true,
    show_skip: true,
    show_add_products: true,
    send_now_label: 'Send Now',
    reschedule_label: 'Reschedule',
    skip_label: 'Skip',
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.MomentCard]: {
    offer_strip_text: '',
    offer_strip_background_color: '#D7FAEB',
    [OmpMomentActionsField]: [],
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.CrossSellCarousel]: {
    section_heading: 'Complete Your Routine',
    description: 'Try something new for up to <strong>{percentage_discount}</strong> Off.',
    heading_size: OmpHeadingSize.Medium,
    max_products_to_show: 15,
    columns_desktop: 4,
    enable_carousel_desktop: true,
    browse_all_style: OmpPillButtonStyle.Text,
    background_color: '#FFFFFF',
    border_color: '#FFFFFF',
    columns_mobile: 1,
    enable_swipe_mobile: true,
    enable_browse_all: true,
    enable_quick_add: true,
    view_all_label: 'View All Products',
    view_all_icon: '',
    card_cta_label: 'Add To Cart',
    card_cta_icon: '',
    display_inside_card: false,
  },
  [OmpSectionKey.FaqSection]: {
    section_heading: 'Frequently Asked Questions',
    heading_text_size: OmpHeadingSize.Medium,
    heading_alignment: OmpHeadingAlignment.Left,
    layout: OmpFaqLayout.SingleColumn,
    description: '',
    faq_ids: [],
    background_color: '#FFFFFF',
    border_color: '#FFFFFF',
    faq_background_color: '#EEEAE8',
    faq_background_color_opacity: 100,
    max_faqs_to_show: 6,
    show_hide_button: true,
    display_inside_card: true,
  },
  [OmpSectionKey.ImageBanner]: {
    desktop_image: '',
    mobile_image: '',
    image_ratio: OmpImageRatio.Adapt,
    alt_text: '',
    image_url: '',
    border_color: '#FFFFFF',
  },
  [OmpSectionKey.Instagram]: {
    section_heading: 'Follow us on instagram',
    description: 'Follow us for tips, recipes, and offers and more.',
    heading_size: OmpHeadingSize.Medium,
    cta_url: '',
    cta_style: OmpPillButtonStyle.FillPill,
    background_color: '#FFFFFF',
    border_color: '#FFFFFF',
    number_of_images: 6,
    image_upload_manually: false,
    layout_preset: OmpInstagramLayout.EqualGrid,
    layout_upload_manually: false,
    display_inside_card: true,
  },
  [OmpSectionKey.NavigationalBlocks]: {
    home_label: 'Home',
    orders_label: 'Orders',
    subscriptions_label: 'Subscriptions',
    address_payment_label: 'Address & Payment',
    log_out_label: 'Log Out',
    show_icons: true,
    show_address_payment: true,
  },
  [OmpSectionKey.SubscriptionList]: {
    section_heading: 'Subscriptions',
    show_track_package: true,
    manage_subscription_label: 'Manage Subscription',
    track_package_label: 'Track Package',
  },
  [OmpSectionKey.OrderList]: {
    section_heading: 'Orders',
    show_track_package: true,
    show_buy_again: true,
    manage_order_label: 'Manage Order',
    track_package_label: 'Track Package',
    buy_again_label: 'Buy Again',
  },
  [OmpSectionKey.OrderSummary]: {
    background_color: '#FFFFFF',
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.TextBox]: {
    section_heading: 'Your Exclusive Benefits',
    heading_size: OmpHeadingSize.Medium,
    description: '',
    background_color: '#FFFFFF',
    background_color_opacity: 100,
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.ShippingAndPayment]: {
    section_heading: 'Shipping and Payment',
    heading_size: OmpHeadingSize.Medium,
    show_edit: true,
    edit_label: 'Edit',
    background_color: '#FFFFFF',
    background_color_opacity: 100,
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.TextAndImage]: {
    section_heading: 'Made For Your Routine',
    heading_size: OmpHeadingSize.Medium,
    description: 'Keep your favourite on repeat and never run out — skip, swap or cancel any time.',
    image: '',
    mobile_image: '',
    alt_text: '',
    layout: OmpTextImageLayout.ImageLeft,
    image_width: 50,
    image_ratio: OmpImageRatio.Adapt,
    image_fit: OmpImageFit.Contain,
    content_alignment: OmpContentAlignment.Center,
    text_alignment: OmpTextAlignment.Left,
    mobile_layout: OmpMobileLayout.ImageFirst,
    cta_enabled: false,
    cta_label: 'Shop Now',
    cta_url: '',
    cta_style: OmpPillButtonStyle.FillPill,
    background_color: '#FFFFFF',
    background_color_opacity: 100,
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.Callout]: {
    tone: OmpCalloutTone.Brand,
    layout: OmpCalloutLayout.Inline,
    icon_name: OmpCalloutIcon.Gift,
    icon: '',
    eyebrow: 'Our best deal yet',
    section_heading: 'Stock Up & Save Big',
    heading_size: OmpHeadingSize.Medium,
    description: 'Add more to your next order and unlock a better price on every item.',
    text_alignment: OmpTextAlignment.Left,
    accent_style: OmpAccentStyle.None,
    accent_color: '',
    cta_enabled: false,
    cta_label: 'See Offer',
    cta_url: '',
    cta_style: OmpPillButtonStyle.FillPill,
    background_color: '#FFFFFF',
    background_color_opacity: 100,
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.Video]: {
    section_heading: 'See It In Action',
    heading_size: OmpHeadingSize.Medium,
    description: '',
    video_url: '',
    cover_image: '',
    aspect_ratio: OmpVideoAspect.SixteenNine,
    autoplay: false,
    loop: false,
    show_controls: true,
    background_color: '#FFFFFF',
    background_color_opacity: 100,
    border_color: '#FFFFFF',
    display_inside_card: true,
  },
  [OmpSectionKey.Columns]: {
    column_count: 2,
    layout: OmpColumnsLayout.Equal,
    column_gap: 16,
    vertical_align: OmpColumnsVerticalAlign.Stretch,
    columns: [
      { key: OmpSectionKey.TextAndImage, data: {} },
      { key: OmpSectionKey.Callout, data: {} },
    ],
  },
};

function ompStripIcon(icon: string, color?: string): string {
  const style = color ? ' style="color: ' + color + ';"' : '';
  return '<i class="omp-icon ' + icon + '"' + style + ' aria-hidden="true"></i>';
}

const OmpMomentStripText: { [moment: number]: string } = {
  [OmpMoment.SubscriptionActive]:
    '<p>' + ompStripIcon('fa-solid fa-circle-check', '#10B981') +
    ' <strong>Your next order is all set!</strong> Scheduled and ready to go</p>',
  [OmpMoment.OrderPending]:
    '<p>' + ompStripIcon('fa-solid fa-clock', '#C17706') +
    " <strong>Your order is being prepared</strong> We'll let you know as soon as it's on the way.</p>",
  [OmpMoment.OrderShipped]:
    '<p>' + ompStripIcon('fa-solid fa-truck') + " <strong>Your order has shipped!</strong> It's on the way</p>",
  [OmpMoment.PaymentIssue]:
    '<p>' + ompStripIcon('fa-solid fa-triangle-exclamation', '#BD3131') +
    ' <strong><span style="color: #BD3131;">Action Needed</span></strong> We couldn\'t process your payment</p>',
  [OmpMoment.SubscriptionCancelled]:
    '<p>' + ompStripIcon('fa-solid fa-heart-crack', '#E03845') +
    " <strong>We'd love to have you back</strong> Reactivate today and save on future shipments</p>",
  [OmpMoment.Trial]:
    '<p>' + ompStripIcon('fa-solid fa-leaf', '#2B5C8A') +
    ' <strong>Your Trial Period is Active</strong> {trial_days_remaining} Days Remaining</p>',
};

export function ompMomentActionDefaults(moment: number): OmpMomentAction[] {
  return ompMomentActionKeys(moment).map((key) => ({
    key: key,
    is_visible: true,
    label: OmpMomentActionDefs[key].label,
    icon: OmpMomentActionDefs[key].icon,
  }));
}

export function ompMomentCardDefaults(moment: number): any {
  const defaults: any = {
    offer_strip_text: OmpMomentStripText[moment] ? OmpMomentStripText[moment] : '',
    offer_strip_background_color: momentStripColor(null, moment),
    [OmpMomentActionsField]: ompMomentActionDefaults(moment),
  };
  if (OmpMomentDiscountMoments.indexOf(moment) >= 0) {
    defaults.show_discount = true;
  }
  defaults.border_color = '#FFFFFF';
  defaults.display_inside_card = true;
  return defaults;
}

const controlsCardDefaults = {
  background_color: '#FFFFFF',
  border_color: '#FFFFFF',
  display_inside_card: true,
};

export function ompControlsDefaults(page: string, moment: number): any {
  const keys = ompControlKeys(page, moment);
  const defaults: any = { ...controlsCardDefaults };
  keys.forEach((key) => {
    const button = OmpControlButtons[key];
    defaults[button.toggle] = true;
    defaults[button.labelField] = ompControlSeedLabel(key);
    if (button.placeable) {
      defaults[button.placementField] = OmpButtonPlacement.PageBottom;
    }
  });
  defaults[OmpPageBottomOrderField] = keys.filter((key) => OmpControlButtons[key].placeable);
  return defaults;
}

export function getOmpSectionDefaults(key: string, page: string, moment?: number): any {
  let defaults = OmpSectionDataDefaults[key];
  const isControls = key === OmpSectionKey.NextOrderDetails;
  const hasMoment = moment != null;
  if (isControls && hasMoment && ompControlKeys(page, moment).length > 0) {
    defaults = ompControlsDefaults(page, moment);
  } else if (key === OmpSectionKey.MomentCard && hasMoment) {
    defaults = ompMomentCardDefaults(moment);
  }
  return defaults;
}

export function seedOmpSectionData(
  key: string,
  data: any,
  page: string,
  moment: number,
  brandVariables: any
): any {
  const target = data ? data : {};
  if (target.cta_enabled === undefined) {
    target.cta_enabled = !!target.cta_label && !!target.cta_url;
  }
  if (key === OmpSectionKey.NextOrderDetails && ompControlKeys(page, moment).length > 0) {
    carryRenamedControlFields(target);
  }
  const defaults = getOmpSectionDefaults(key, page, moment);
  const colors = paletteSectionDefaults(brandVariables, key, target.tone, moment);
  if (defaults) {
    Object.keys(defaults).forEach((field) => {
      if (target[field] === undefined) {
        let value = colors[field] !== undefined ? colors[field] : defaults[field];
        if (value !== null && typeof value === 'object') {
          value = JSON.parse(JSON.stringify(value));
        }
        target[field] = value;
      }
    });
  }
  if (key === OmpSectionKey.NextOrderDetails) {
    clearMatchingControlLabels(target, page, moment);
  }
  if (key === OmpSectionKey.MomentCard) {
    target[OmpMomentActionsField] = reconcileMomentActions(target[OmpMomentActionsField], moment);
  }
  return target;
}

const OmpRenamedMomentActions: { [legacy: string]: OmpMomentActionKey } = {
  resume_subscription: OmpMomentActionKey.RebillItem,
};

const OmpRetiredMomentLabels: { [key: string]: string } = {
  [OmpMomentActionKey.RebillItem]: 'Resume Subscription',
};

function ompMomentLabel(key: string, label: any): string {
  let resolved = OmpMomentActionDefs[key].label;
  if (typeof label === 'string' && label && label !== OmpRetiredMomentLabels[key]) {
    resolved = label;
  }
  return resolved;
}

function reconcileMomentActions(saved: any, moment: number): OmpMomentAction[] {
  const keys = ompMomentActionKeys(moment);
  const list: OmpMomentAction[] = (Array.isArray(saved) ? saved : []).map((action) => {
    let renamed = action;
    if (action && OmpRenamedMomentActions[action.key]) {
      renamed = { ...action, key: OmpRenamedMomentActions[action.key] };
      renamed.label = ompMomentLabel(renamed.key, renamed.label);
    }
    return renamed;
  });
  const kept = list.filter((action) => action && keys.indexOf(action.key) >= 0);
  const missing = ompMomentActionDefaults(moment).filter((fallback) => !kept.some((action) => action.key === fallback.key));
  return kept.concat(missing).map((action) => ({
    key: action.key,
    is_visible: action.is_visible !== false,
    label: typeof action.label === 'string' ? action.label : OmpMomentActionDefs[action.key].label,
    icon: typeof action.icon === 'string' ? action.icon : OmpMomentActionDefs[action.key].icon,
  }));
}

function ompLegacyMomentField(key: string): string {
  let field = key;
  Object.keys(OmpRenamedMomentActions).forEach((legacy) => {
    if (OmpRenamedMomentActions[legacy] === key) {
      field = legacy;
    }
  });
  return field;
}

export function ompMomentCardFromNextOrderDetails(data: any, moment: number): any {
  const source = data ? data : {};
  const converted: any = {
    offer_strip_text: source.offer_strip_text,
    [OmpMomentActionsField]: ompMomentActionKeys(moment).map((key: OmpMomentActionKey) => {
      const def = OmpMomentActionDefs[key];
      const field = ompLegacyMomentField(key);
      const label = source[field + '_label'];
      return {
        key: key,
        is_visible: source['show_' + field] !== false,
        label: ompMomentLabel(key, label),
        icon: def.icon,
      };
    }),
    border_color: source.border_color,
    display_inside_card: source.display_inside_card,
  };
  Object.keys(converted).forEach((field) => {
    if (converted[field] === undefined) {
      delete converted[field];
    }
  });
  return converted;
}

const OmpRenamedControlKeys: { legacy: OmpLegacyControlKey; key: OmpControlKey }[] = [
  { legacy: OmpLegacyControlKey.Swap, key: OmpControlKey.SwapProduct },
  { legacy: OmpLegacyControlKey.Delay, key: OmpControlKey.Pause },
  { legacy: OmpLegacyControlKey.TrackOrder, key: OmpControlKey.TrackPackage },
];

function carryField(target: any, field: string, replacement: string) {
  if (target[field] !== undefined) {
    if (target[replacement] === undefined) {
      target[replacement] = target[field];
    }
    delete target[field];
  }
}

function carryRenamedControlFields(target: any) {
  OmpRenamedControlKeys.forEach((renamed) => {
    carryField(target, ompControlToggleField(renamed.legacy), ompControlToggleField(renamed.key));
    carryField(target, ompControlLabelField(renamed.legacy), ompControlLabelField(renamed.key));
  });
}

function clearMatchingControlLabels(target: any, page: string, moment: number) {
  ompControlKeys(page, moment).forEach((key) => {
    const button = OmpControlButtons[key];
    if (target[button.labelField] === button.displayLabel) {
      target[button.labelField] = '';
    }
  });
}

export function newOmpColumnChild(key: string, page: string, moment: number, brandVariables: any) {
  return { key: key, data: seedOmpSectionData(key, {}, page, moment, brandVariables) };
}
